import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { LiveStreamDetails, LiveStreamState } from '../../../interfaces/live';
import { ClipboardService } from 'ngx-clipboard';
import { OverlayService } from '../../../services/overlay.service';
import { Publication } from '../../../interfaces/publication';
import { PublicationService } from '../../../services/publication.service';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'mediaclip-details-live',
	templateUrl: './mediaclip-details-live.component.html',
	styleUrls: ['./mediaclip-details-live.component.scss']
})
export class MediaclipDetailsLiveComponent implements OnInit, OnChanges, OnDestroy {
	@Input() mediaclip: any;
	@Input() form: NgForm;
	@Input() liveStreamDetails: LiveStreamDetails;

	isPaused: boolean;
	isRecordingFromStart: boolean;
	showKey: boolean[] = [];
	showIngestUrl = false;
	showBackupIngestUrl = false;
	allowRecording = false;
	allowBackupIngestFeed = false;

	private subscriptions = new Subscription();

	constructor(
		private clipboardService: ClipboardService,
		private overlayService: OverlayService,
		private publicationService: PublicationService
	) {
		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication) {
				this.allowBackupIngestFeed = publication.allowBackupIngestFeed;
			}
		}));
	}

	initializeLiveStreamTab(): void {
		if (this.liveStreamDetails && this.liveStreamDetails.data) {
			this.isPaused = this.liveStreamDetails.data.state === LiveStreamState.paused;
			this.isRecordingFromStart = this.liveStreamDetails.data.recording;

			for (let i = 0; i < this.liveStreamDetails.data.ingest.length; i++) {
				this.showKey.push(false);
			}

			// Recording is allowed on RTMP and Webdav streams, not on Icecast
			if (this.liveStreamDetails.data['ingest-type'] === 'rtmp' || this.liveStreamDetails.data['ingest-type'] === 'webdav') {
				this.allowRecording = true;
			}
		}
	}

	ngOnInit() {
		this.initializeLiveStreamTab();
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.liveStreamDetails) {
			this.initializeLiveStreamTab();
		}
	}

	onPausedChange(onPausedChange: any): void {
		this.liveStreamDetails.data.state =
			(this.liveStreamDetails.data.state === LiveStreamState.paused) ? LiveStreamState.available : LiveStreamState.paused;
		this.isPaused = this.liveStreamDetails.data.state === LiveStreamState.paused;

		this.form.form.markAsDirty();
	}

	onRecordingChange(onRecordingChange: any): void {
		this.form.form.markAsDirty();
	}

	copyToClipboard(str: string): void {
		this.clipboardService.copyFromContent(str);
		this.overlayService.createToast('Copied to clipboard', 'clipboard');
	}

	toggleKeyVisibility(index: any) {
		if (typeof this.showKey[index] !== 'undefined') {
			this.showKey[index] = !this.showKey[index];
		}
	}

	toggleIngestUrlVisibility() {
		this.showIngestUrl = !this.showIngestUrl;
	}

	toggleBackupIngestUrlVisibility() {
		this.showBackupIngestUrl = !this.showBackupIngestUrl;
	}
}
